import React from 'react';
import { Link } from 'react-router-dom';
import './billing.css';

/** Landing page for Stripe Checkout cancelled redirects. */
const CancelledPage: React.FC = () => {
  return (
    <div className="billing-page">
      <section className="billing-card" aria-label="Payment cancelled">
        <h1>Payment cancelled</h1>
        <p className="billing-status">
          No charge was made. You can try again whenever you&apos;re ready.
        </p>
        <Link className="billing-primary billing-link" to="/billing">
          Back to billing
        </Link>
      </section>
    </div>
  );
};

export default CancelledPage;
